<template>
  <tr>
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding">
      <input type="checkbox"
             :id="'favCheckbox'+entity.id"
             :value="entity.id"
             @click.stop
             @change="onChange"
             :checked="isChecked"
      />
      <label
          :for="'favCheckbox'+entity.id"
          @click.stop
          v-translate>Vybrat
      </label>
    </td>
    <td :data-th="'Název'" class="first_data"><strong>{{ entity.name }}</strong></td>
    <td :data-th="'Uživatelský profil'">
      <entity-link :id="entity.id_subscriber_profile" type="subscriberProfile">{{ entity.subscriber_profile_name }}</entity-link>
    </td>
    <td :data-th="'Vytvořilo zařízení'">
      <entity-link :id="entity.id_device" type="device">{{ entity.device_name }}</entity-link>
    </td>
    <td :data-th="'Datum vytvoření'" v-html="$_date_formatFull(entity.timestamp_created)"></td>
    <td class="no_padding edit">
      <div class="edit_inner">
        <a v-if="isDeletable" class="btn btn_action btn_delete" @click.stop="onDeleteFavoriteShow" :title="$gettext('Smazat')">{{
            $gettext('Smazat')
          }}</a>
      </div>
    </td>
  </tr>
</template>

<script>
import rowActions from "@/components/mixins/row-actions"
import EntityLink from "../../../common/EntityLink.vue";

export default {
  name: "FavoriteShowRow",
  components: { EntityLink },
  mixins: [rowActions],
  props: {
    entity: Object,
    enabled: Boolean,
    isDeletable: Boolean,
  },
  methods: {
    onDeleteFavoriteShow() {
      this.$emit('deleteFavoriteShow', this.entity.id);
    },
  },
};

</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/favoriteShows/FavoriteShowsRow.vue